module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273a1641"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 154
// module chunks = 1